<template>
  <div class="container-fluid">
    <div class="col">
      <ProjectsNavigationBar v-bind:userProjects="userProjects"
                             v-bind:selectedProjectId="selectedProjectId"
                             v-bind:table="selectedTable"
                             v-bind:tableCollections="collections"
                             v-on:select-project="selectProject"
                             v-on:unselect-project="unselectProject"
                             v-on:collection-filter-change="onCollectionFilterChange"></ProjectsNavigationBar>
    </div>

    <div v-if="selectedTable" >
      <Table :tableId="selectedTable.id"></Table>
    </div>

    <div v-if="(!selectedTable) && (selectedProjectId)" class="col">
      <div class="col text-left">
        <div class="container-fluid">
          <div class="row align-items-center">
            <h1 class="my-auto">Tables list</h1>
            <TablesUploader v-on:some-tables-are-created="updateTables"/>
            <div class="pr-2">
              <a href="#" class="my-auto mb-4 mt-3 ml-2 mr-2 btn btn-sm btn-secondary" v-on:click="refreshTables" title="Refresh" :style="{'height': '30px'}">
                <span class="mr-2 d-none d-md-inline-block">Refresh</span>
                <span class="icon icon-reload mr-0"></span>
              </a>
            </div>
            <div class="col">
            </div>
            <div class="row align-items-center">
              <label class="align-middle mx-auto my-auto">Display:</label>
              <ul class="rounded mr-2 ml-2 nav nav-pills" id="pills-tab" role="tablist">
                <li class="nav-item ml-0 mr-0" role="presentation">
                  <span class="mt-1 mb-1 mr-0 ml-0 btn btn-sm btn-secondary icon icon-Keypad" aria-hidden="true" v-on:click="cards = true" :class="{active: cards === true}"></span>
                </li>
                <li class="nav-item ml-0 mr-0" role="presentation">
                  <span class="mt-1 mb-1 mr-0 ml-0 btn btn-sm btn-secondary icon icon-servers" aria-hidden="true" v-on:click="cards = false" :class="{active: cards === false}"></span>
                </li>
              </ul>              
            </div>
          </div>
          <div class="row align-items-center" :style="{'min-height': '50px'}">
            <div class="dropdown mb-1">
              <div class="d-flex">

                <label class="my-auto">Status Filters:</label>

                <div class="position-relative" id="tablesFiltersBoundaryContainer" :style="{'display': 'block'}">

                  <a id="tablesFiltersSelector" class="align-items-center position-relative my-auto mb-4 mt-3 ml-2 p-1 btn btn-sm btn-secondary" data-boundary="tablesFiltersBoundaryContainer" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" :style="{'height': '30px'}">
<!--
                    <span class="icon icon-filter mx-auto my-auto" :style="{'height': '32px'}" title="Select filters"><small class="badge badge-light pb-0 badge-secondary ml-1 align-middle text-monospace">{{ iconFilterText }}</small></span>
-->
                    <div class="row" :style="{'height': '32px'}" title="Select filters">
                      <span class="icon icon-filter mx-auto my-auto pl-2"></span>
                      <small class="badge badge-light pb-0 badge-secondary align-middle my-auto ml-1 mr-2 pr-1 pl-1 pt-0 align-middle text-monospace" :style="{'margin-top': '10px !important'}">{{ iconFilterText }}</small>
                    </div>
                  </a>

                  <ul class="dropdown dropdown-menu dropdown-menu-left dropdown-menu-bottom mt-0 mb-1" role="menu" aria-labelledby="tablesFiltersSelector" id="tablesFiltersCollapse">
                    <div class="px-1 py-1">
                      <div data-target="tablesFiltersCollapse" class="custom-control custom-checkbox secondary my-1 black-and-white-checkbox" onClick="document.getElementById('allFilter').click(); event.stopPropagation();">
                        <input type="checkbox" class="custom-control-input" id="allFilter" v-on:click="toggleAllFilter($event)" :checked="isAllFilterSelected">
                        <label class="custom-control-label ml-1" for="allFilter" ><small>All</small></label>
                      </div>
                      <div class="dropdown-divider"></div>

                      <div v-for="possibleStatusFilter in displayedStatusFilters" :key="'dropdown-filter-div-'+possibleStatusFilter" data-target="tablesFiltersCollapse" class="custom-control custom-checkbox my-1 black-and-white-checkbox" v-on:click="onCheckboxDivClicked($event, possibleStatusFilter)" :style="{'width': '16rem'}">
                        <input type="checkbox" class="custom-control-input" :id="'checkbox-'+possibleStatusFilter" v-on:click="toggleFilter(possibleStatusFilter)" :checked="selectedFilters.includes(possibleStatusFilter)">
                        <label class="custom-control-label ml-1" :for="'checkbox-'+possibleStatusFilter"><small>{{ getStatusDisplayedName(possibleStatusFilter) }}</small></label>
                      </div>

                      <div class="dropdown-divider d-none"></div>
                      <li href="#" class="dropdown-item btn btn-sm d-none" v-on:click="applyFilters($event)" :active="false">Apply filter</li>
                    </div>
                  </ul>

                </div>

              </div>

            </div>
            <div class="col"></div>
            <div v-if="cards" class="dropdown mb-1">
              <label class="mr-1">Ordered by:</label>
              <button class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" id="dropdownMenu1">{{ sort }}</button>
              <div class="dropdown-menu " aria-labelledby="dropdownMenu1">
                <span class="dropdown-item" v-for="orderingOption in tableOrderingOptionsList" :key="orderingOption.msg" v-on:click="selectSortColumn(orderingOption.msg)">{{ orderingOption.msg }}</span>
              </div>
            </div>
            <div v-if="cards" class="ml-2 dropdown d-none d-lg-inline-block mb-1">
              <label class="mr-1">Columns:</label>
              <button class="btn btn-secondary dropdown-toggle" data-toggle="dropdown" id="dropdownColumns1">{{ columns }}</button>
              <div class="dropdown-menu " aria-labelledby="dropdownColumns1">
                <span class="dropdown-item" v-for="columnsOption in tableColumnsList" :key="columnsOption.msg" v-on:click="selectNumberOfColumns(columnsOption.msg)">{{ columnsOption.msg }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Tables v-if="!cards"
              v-bind:tables="pages[currentPageIndex]"
              v-bind:sort="sort"
              v-bind:sortDirection="sortDirection"
              v-on:delete-table="deleteTable($event)"
              v-on:select-table="selectTable( $event )"
              v-on:select-ordering-column="selectSortColumn($event)"
              v-on:refresh-table="updateTables($event)"
              v-on:launch-preprocessing="startTablePreProcessing($event)"
              v-on:launch-annotation="startTableAnnotation($event)"
              v-on:refresh-tables="updateTables($event)">
      </Tables>

      <TablesOrderingMenu v-if="cards == 'toto'"
                          class="col-1"
                          v-bind:tableOrderingOptionsList="tableOrderingOptionsList"
                          v-on:select-ordering-column="selectSortColumn($event)">
      </TablesOrderingMenu>

      <CardsTables v-if="cards"
                   v-bind:tables="pages[currentPageIndex]"
                   v-bind:columns="columns"
                   v-on:delete-table="deleteTable($event)"
                   v-on:select-table="selectTable($event)"
                   v-on:refresh-table="updateTables($event)"
                   v-on:launch-preprocessing="startTablePreProcessing($event)"
                   v-on:launch-annotation="startTableAnnotation($event)"
                   v-on:refresh-tables="updateTables($event)"
                   v-on:delete-collection-in-table="deleteCollectionInTable"></CardsTables>

      <TablesPaginationMenu :pagesProp="pages"
                            :pageSizeProp="pageSize"
                            :currentPageIndexProp="currentPageIndex"
                            v-on:setPageSize="changePageSize($event)"
                            v-on:setCurrentPageIndex="currentPageIndex = $event">
      </TablesPaginationMenu>

    </div>

    <div v-if="(!selectedTable) && (!selectedProjectId)" class="col">
      <ProjectsList
          v-bind:columns=3
          v-bind:projects="userProjects"
          v-on:select-project="selectProject"
          v-on:a-project-was-created="updateProjects"
          v-on:a-project-was-deleted="updateProjects"></ProjectsList>
    </div>

  </div>
</template>

<script>
import ProjectsNavigationBar from '@/components/project/ProjectsNavigationBar.vue'
import TablesOrderingMenu from '@/components/project/TablesOrderingMenu.vue'
import TablesPaginationMenu from "../components/project/TablesPaginationMenu";

import TablesUploader from '@/components/project/TablesUploader.vue'
import Tables from '@/components/project/Tables.vue'
import CardsTables from '@/components/project/CardsTables.vue'

import Table from "../components/project/Table";
import ProjectsList from "../components/project/ProjectsList";
import MessageDisplayerService from '../utils/MessageDisplayerService';

import TableApi from '../generatedApiClient/api/endpoints/TableApi';
import CreateProjectRequest from "../generatedApiClient/api/model/CreateProjectRequest";
import ProjectApi from '../generatedApiClient/api/endpoints/ProjectApi';

let projectApiInstance = new ProjectApi();
let tableApiInstance = new TableApi();

const allPossibleStatusFilters = [
  'UPLOADED',
  'PRE PROCESSING IN PROGRESS',
  'PRE PROCESSING IN ERROR',
  'PRE PROCESSING FAILED',
  'PRE PROCESSING DONE',
  'ANNOTATION IN PROGRESS',
  'ANNOTATION IN ERROR',
  'ANNOTATION FAILED',
  'ANNOTATION DONE',
];

export default {
  name: "Projects",
  components: {
    TablesPaginationMenu,
    ProjectsNavigationBar,
//    TablesFilteringMenu,
    TablesOrderingMenu,
    TablesUploader,
    Tables,
    CardsTables,
    Table,
    ProjectsList
  },
  data() {
    return {
      userProjects: undefined,
      selectedTable: undefined,
      cards: true,
      tables: [],
      filter: undefined,
      sort: "creationDate",
      columns: "byDefault",
      sortDirection: "desc",
      tableOrderingOptionsList: [
        {msg: 'creationDate', class: ''},
        {msg: 'name', class: ''},
        {msg: 'path', class: ''},
        {msg: 'status', class: ''}
      ],
      tableColumnsList: [
        {msg: 'byDefault', class: ''},
        {msg: '1', class: ''},
        {msg: '2', class: ''},
        {msg: '3', class: ''}
      ],
      tableFilterOptionsList: [
        {msg: 'All', class: 'list-group-item-primary'},
        //{msg: 'only:Raw', class: 'list-group-item-light'},
        {msg: 'only:Preprocessing', class: 'list-group-item-warning'},
        {msg: 'already:Preprocessed', class: 'list-group-item-light'},
        {msg: 'only:Annotation in progress', class: 'list-group-item-info'},
        {msg: 'already:Annotated', class: 'list-group-item-success'}],
      pageSize: 30,
      currentPageIndex: 0,
      selectedFilters: allPossibleStatusFilters,
      isAllFilterSelected: true,
      collectionsFilter: []
    };
  },
  mounted() {
    this.getOrCreateProjects()
        .then(() => {
          this.updateTables();
        })
        .catch(() => {
          // do nothing
        });
  },
  computed: {
    collections: function () {
      console.log(this.$store.state.selectedProject)
     return (this.$store.state.selectedProject !== undefined) ? this.$store.state.selectedProject.collections : [];
    },
    signedUser: function() {
      return (this.$store.state.identityIdentified !== undefined) ? this.$store.state.identityIdentified.email : undefined;
    },
    selectedProjectId: function() {
      return (this.$store.state.selectedProject !== undefined) ? this.$store.state.selectedProject.id : undefined;
    },
    pages: function () {
      let tmpPages = [];
      // const filteredTempTab = this.filterTable(this.tables, this.filter);
      const filteredTempTab = this.filterTable(this.tables, this.selectedFilters);
      const sortedTempTab = this.sortTable(filteredTempTab, this.sort, this.sortDirection);

      let lastPageIndex = Math.floor(sortedTempTab.length / this.pageSize);
      for (let i = 0; i < lastPageIndex; i++) {
        tmpPages.push(sortedTempTab.slice(i * this.pageSize, (i + 1) * this.pageSize));
      }
      if ((sortedTempTab.length % this.pageSize) != 0) {
        tmpPages.push(sortedTempTab.slice(this.pageSize * lastPageIndex, this.pageSize * lastPageIndex + sortedTempTab.length % this.pageSize))
      }
      return tmpPages;
    },
    displayedStatusFilters: function() {
      return allPossibleStatusFilters;
    },
    iconFilterText: function() {
      const numberOfPossibleStatusFilters = allPossibleStatusFilters.length;
      const numberOfSelectedFilters = this.selectedFilters.length;
      if (numberOfPossibleStatusFilters === numberOfSelectedFilters) {
        return 'None';
      } else {
        return (numberOfPossibleStatusFilters - numberOfSelectedFilters);
      }
    }
  },
  methods: {
    onCollectionFilterChange: function (collectionsFilter) {
      this.collectionsFilter = collectionsFilter;
      console.log("[onCollectionFilterChange] TODO " + JSON.stringify(collectionsFilter));
    },
    deleteCollectionInTable: function (signedUser, selectedProjectId, tableId, tableProjectCollection) {
      this.updateAuthJwtToken(tableApiInstance);

        tableApiInstance.patchTable(signedUser, selectedProjectId, tableId,{
          "projectCollection": null
        }  )
            .then(patchTableResp => {
              console.log("[deleteCollectionInTable] [API] [patchTableResp] [OK]" + patchTableResp);
              this.refreshTables();

            })
            .catch(patchTablError => {
              console.log("[onSetCollectionSubmit] [API] [patchTableResp] [ERROR]", patchTablError);
            });

      console.log("[deleteCollectionInTable] TODO " + signedUser +' '+ selectedProjectId + ' ' + tableId +' ' + tableProjectCollection);
    },
    updateAuthJwtToken: function (apiInstance) {
      if (apiInstance && apiInstance.apiClient && apiInstance.apiClient.authentications && apiInstance.apiClient.authentications['AuthJWT']) {
        apiInstance.apiClient.authentications['AuthJWT'].accessToken = this.$store.state.identityIdentified.token;
      }
    },
    getOrCreateProjects: function () {
      return new Promise((resolve, reject) => {
        this.updateAuthJwtToken(projectApiInstance);
        projectApiInstance.getProjects(this.signedUser)
            .then(getProjectsResp => {
              console.log("[getOrCreateProjects] [API] [getProjects] [OK]");
              this.userProjects = getProjectsResp;
              // TODO many projects
              if (getProjectsResp.length === 1) {
                this.$store.commit('selectProject', { id: getProjectsResp[0].id, name: getProjectsResp[0].name });
                resolve(getProjectsResp[0]);
              } else if (getProjectsResp.length === 0) {
                this.updateAuthJwtToken(projectApiInstance);
                projectApiInstance.createProject(this.signedUser, new CreateProjectRequest('myProject1'))
                    .then(createProjectResp => {
                      console.log("[getOrCreateProjects] [API] [createProject] [OK]");
                      this.$store.commit('selectProject', { id: createProjectResp.id, name: createProjectResp.name });
                      resolve(createProjectResp);
                    })
                    .catch(createProjectError => {
                      console.log("[getOrCreateProjects] [API] [createProject] [ERROR]", createProjectError);
                      reject(createProjectError);
                    });
              }
            })
            .catch(getProjectsError => {
              console.log("[getOrCreateProjects] [API] [getProjects] [ERROR]", getProjectsError);
              reject(getProjectsError);
            });
      });
    },
    updateTables: function () {
      this.updateAuthJwtToken(tableApiInstance);
      tableApiInstance.getTables(this.signedUser, this.selectedProjectId)
          .then(getTablesResp => {
            console.log("[updateTables] [API] [getTables] [OK]");
            this.tables = getTablesResp;
            // TODO extract collection names set from tables
          })
          .catch(getTablesError => {
            console.log("[updateTables] [API] [getTables] [ERROR]", getTablesError);
          });
    },
    updateProjects: function () {
      this.updateAuthJwtToken(projectApiInstance);
      projectApiInstance.getProjects(this.signedUser)
          .then(getProjectsResp => {
            console.log("[updateProjects] [API] [getProjects] [OK]");
            this.userProjects = getProjectsResp;

          })
          .catch(getProjectsError => {
            console.log("[updateProjects] [API] [getProjects] [ERROR]", getProjectsError);
          });
    },
    deleteTable: function (tableId) {
      return new Promise((resolve, reject) => {
        this.updateAuthJwtToken(tableApiInstance);
        tableApiInstance.deleteTable(this.signedUser, this.selectedProjectId, tableId)
          .then(deleteTableResp => {
            console.log("[deleteTable] [API] [deleteTable] [OK]");
            this.updateTables();
            resolve(deleteTableResp);
          })
          .catch(deleteTableError => {
            console.log("[deleteTable] [API] [deleteTable] [ERROR]", deleteTableError);
            reject(deleteTableError);
          });
      });
    },
    startTablePreProcessing: function(tableId) {
      return new Promise((resolve, reject) => {
        this.updateAuthJwtToken(tableApiInstance);
        tableApiInstance.launchPreProcessing(this.signedUser, this.selectedProjectId, tableId)
          .then(launchPreProcessingResp => {
            console.log("[startTablePreProcessing] [API] [launchPreProcessing] [OK]");
            this.updateTables();
            resolve(launchPreProcessingResp);
          })
          .catch(launchPreProcessingError => {
            console.log("[startTablePreProcessing] [API] [launchPreProcessing] [ERROR]", launchPreProcessingError);
            // To reset status from real table
            this.updateTables();
            reject(launchPreProcessingError);
          });
      });
    },
    startTableAnnotation: function(tableId) {
      return new Promise((resolve, reject) => {
        this.updateAuthJwtToken(tableApiInstance);
        tableApiInstance.launchAnnotation(this.signedUser, this.selectedProjectId, tableId)
            .then(launchAnnotationResp => {
              console.log("[startTableAnnotation] [API] [launchAnnotation] [OK]");
              this.updateTables();
              resolve(launchAnnotationResp);
            })
            .catch(launchAnnotationError => {
              console.log("[startTableAnnotation] [API] [launchAnnotation] [ERROR]", launchAnnotationError);
              // To reset status from real table
              this.updateTables();
              reject(launchAnnotationError);
            });
      });
    },
    filterTable: function (tableToFilter, filterToApply) {
      let returnedTable = tableToFilter.filter(tableContent => {
        if ( filterToApply.includes(tableContent.status) ) {
          if (tableContent.projectCollection) {
            if (this.collectionsFilter.length == 0) {
              return false
            } else {
              return (this.collectionsFilter.includes(tableContent.projectCollection));
            }
          } else {
            return true;
          }
        } else {
          return false;
        }

      });

    // Filtrer les tables  sur les collections

      /*
      if (filterToApply === "only:Raw") {
        returnedTable = tableToFilter.filter(tableContent => ["UPLOADED"].includes(tableContent.status));
      } else if (filterToApply === "only:Preprocessing") {
        returnedTable = tableToFilter.filter(tableContent => ["PRE PROCESSING IN PROGRESS"].includes(tableContent.status));
      } else if (filterToApply === "only:Annotation in progress") {
        returnedTable = tableToFilter.filter(tableContent => ["ANNOTATION IN PROGRESS"].includes(tableContent.status));
      } else if (filterToApply === "already:Preprocessed") {
        returnedTable = tableToFilter.filter(tableContent => ["PRE PROCESSING DONE", "ANNOTATION IN PROGRESS", "ANNOTATION DONE"].includes(tableContent.status));
      } else if (filterToApply === "already:Annotated") {
        returnedTable = tableToFilter.filter(tableContent => ["ANNOTATION DONE"].includes(tableContent.status));
      }
      */
      return returnedTable;
    },
    selectSortColumn(sortColumn) {
      if (sortColumn === this.sort) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sort = sortColumn;
        this.sortDirection = "asc";
        let newTable = this.tableOrderingOptionsList.filter(t => t.msg == this.sort);
        this.tableOrderingOptionsList.forEach(t => {
          if (t.msg !== this.sort) {
            newTable.push(t);
          }
        })
        this.tableOrderingOptionsList = newTable;

      }
    },
    selectNumberOfColumns(column) {
      if (column === this.sort) {
        // Do nothing
      } else {
        this.columns = column;
      }
    },
    sortTable: function (tableToFilter, sortToApply, sortDirectionToApply) {
      const returnedTable = tableToFilter.sort((tabContent1, tabContent2) => {
        if (sortDirectionToApply === "asc") {
          return tabContent1[sortToApply].localeCompare(tabContent2[sortToApply]);
        } else {
          return tabContent2[sortToApply].localeCompare(tabContent1[sortToApply]);
        }
      });
      return returnedTable;
    },
    selectTable: function (event) {
      // not yet ready
      this.selectedTable = event
    },
    selectProject: function(project){

      this.$store.commit('selectProject', { id: project.id, name: project.name, collections: project.collections });

      this.refreshTables();
    },
    unselectProject: function(){
      this.selectedTable = undefined;
      this.$store.commit('selectProject', undefined);
    },
    refreshTables: function() {
      this.selectedTable=undefined;
      this.updateAuthJwtToken(tableApiInstance);
      tableApiInstance.getTables(this.signedUser, this.selectedProjectId, {withRefresh:true})
        .then(getTablesResp => {
          console.log("[refreshTables] [API] [getTables] [OK]");
          this.tables = getTablesResp;
          MessageDisplayerService.showSuccessMessage(MessageDisplayerService.METHOD_NAMES.METHOD_GET_TABLES);
        })
        .catch(getTablesError => {
          console.log("[refreshTables] [API] [getTables] [ERROR]", getTablesError);
          MessageDisplayerService.showErrorMessage(MessageDisplayerService.METHOD_NAMES.METHOD_GET_TABLES, getTablesError);
        });
    },
    refreshTable: function(){
      this.selectedTable=undefined;
      this.updateAuthJwtToken(tableApiInstance);
      tableApiInstance.getTables(this.signedUser, this.selectedProjectId, { withRefresh:'true'})
        .then(getTablesResp => {
          console.log("[refreshTable] [API] [getTables] [OK]");
          this.tables = getTablesResp;
        })
        .catch(getTablesError => {
          console.log("[refreshTable] [API] [getTables] [ERROR]", getTablesError);
        });
    },
    toggleAllFilter: function() {
      // reset page index on filter updated
      this.currentPageIndex = 0;
      if (this.isAllFilterSelected === true) {
        this.selectedFilters = [];
        this.isAllFilterSelected = false;
      } else {
        this.selectedFilters = allPossibleStatusFilters;
        this.isAllFilterSelected = true;
      }
    },
    toggleFilter: function(filterName) {
      // reset page index on filter updated
      this.currentPageIndex = 0;
      if (this.selectedFilters.includes(filterName)) {
        if (this.isAllFilterSelected === true) {
          this.isAllFilterSelected = undefined;
          document.getElementById('allFilter').indeterminate = true;
        }
        this.selectedFilters = this.selectedFilters.filter(elem => elem !== filterName);
        if (this.selectedFilters.length === 0) {
          this.isAllFilterSelected = false;
          document.getElementById('allFilter').indeterminate = false;
        }
      } else {
        if (this.isAllFilterSelected === false) {
          this.isAllFilterSelected = undefined;
          document.getElementById('allFilter').indeterminate = true;
        }
        this.selectedFilters.push(filterName);
        if (this.selectedFilters.length === allPossibleStatusFilters.length) {
          this.isAllFilterSelected = true;
          document.getElementById('allFilter').indeterminate = false;
        }
      }
    },
    getStatusDisplayedName: function(status) {
      let returnedStatusDisplayedName;
      switch (status) {
        case 'UPLOADED':
        case 'PRE PROCESSING IN PROGRESS':
        case 'PRE PROCESSING IN ERROR':
        case 'PRE PROCESSING FAILED':
        case 'ANNOTATION IN PROGRESS':
        case 'ANNOTATION IN ERROR':
        case 'ANNOTATION FAILED':
          returnedStatusDisplayedName = status;
          break;
        case 'PRE PROCESSING DONE':
          returnedStatusDisplayedName = 'PRE PROCESSED';
          break;
        case 'ANNOTATION DONE':
          returnedStatusDisplayedName = 'ANNOTATED';
          break;
      }
      return returnedStatusDisplayedName;
    },
    onCheckboxDivClicked: function(event, filterName) {
      document.getElementById('checkbox-'+filterName).click();
      event.stopPropagation();
    },
    changePageSize: function(event) {
      this.currentPageIndex = 0;
      this.pageSize = event;
    }
  }
};
</script>
<style scoped>

.black-and-white-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  background-color: black;
}

.black-and-white-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  border-color: rgb(204, 204, 204);
  background-color: white;
}

.black-and-white-checkbox .custom-control-input:not(:disabled):active ~ .custom-control-label::before {
/*
  color: yellow;
*/
  background-color: white;
  border-color: rgb(204, 204, 204);
}

.black-and-white-checkbox .custom-control-input ~ .custom-control-label::before {
/*
  border-color: blue;
*/
  color: rgb(204, 204, 204);
  background-color: rgb(204, 204, 204);
}


</style>